import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Room } from '../models/room';
import { RoomDialogComponent } from './dialogs/room-dialog/room-dialog.component';
import { RoomService } from '../services/room.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss'],
  entryComponents: [
    RoomDialogComponent
  ]
})
export class RoomComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'name', 'edit', 'delete'];

  constructor(
    private _roomService: RoomService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadRooms()
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadRooms() {

    this.sub = this._roomService.select()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new Room();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: Room = new Room();

    if (entity) {
      data = entity;
    }

    this.dialog.open(RoomDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '280px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir esta Sala?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._roomService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete room error: " + error.message) }
          )
      }
    })
  }

}
